export class ReportDetailsByJurisdiction {
  reportId: Number;
  localEntityId?: Number;
  localEntityName?: String;
  tradingPartnerName?: String;
  reportName: String;
  reportLanguage: String;
  reportCreationDate: Date;
  reportStatus: String;
  reportInstanceBinaryPath: String;
  taxJurisdiction?: String;
  taxJurisdictionCode?: String;
  isFinalVersion: Number;
}
